:host {
  @include reset-host;
}

:host .title-bar {
  display: inline-block;
  padding: 8px 16px;

  font-weight: $fw-regular;
  font-size: rem(40);
  line-height: 1.2;

  border-radius: rem(8);
  transform: rotate(-3deg);
  transform-origin: bottom left;

  &.is-pink-variant {
    color: $color-purple;

    background: $color-purple-light;
  }

  &.is-purple-variant {
    color: $white;

    background: $color-purple;
  }

  &.is-blue-variant {
    color: $color-blue-dark;

    background: $white;
  }

  &.has-xs-margin {
    margin-bottom: map-get($spacing-sizes, 1);
  }

  &.has-sm-margin {
    margin-bottom: map-get($spacing-sizes, 2);
  }

  &.has-md-margin {
    margin-bottom: map-get($spacing-sizes, 3);
  }

  &.has-lg-margin {
    margin-bottom: map-get($spacing-sizes, 4);
  }

  &.has-xl-margin {
    margin-bottom: map-get($spacing-sizes, 5);
  }

  em {
    font-family: $ff-title;
    font-style: normal;
    line-height: 0;
  }
}
